/* eslint-disable @scandipwa/scandipwa-guidelines/no-jsx-variables */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable react/prop-types */
/* eslint-disable max-lines */
/* eslint-disable react/no-unknown-property */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/boolean-prop-naming */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */
// Disabled due placeholder needs

import PropTypes from 'prop-types';

import AddToCart from 'Component/AddToCart';
import ExpandableContent from 'Component/ExpandableContent';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import PRODUCT_TYPE from 'Component/Product/Product.config';
import ProductColorAttribute from 'Component/ProductColorAttribute';
import ProductConfigurableAttributes from 'Component/ProductConfigurableAttributes';
import ProductCustomizableOptions from 'Component/ProductCustomizableOptions';
import ProductGallery from 'Component/ProductGallery';
import ProductLabel from 'Component/ProductLabel';
import ProductPrice from 'Component/ProductPrice';
import ProductWishlistButton from 'Component/ProductWishlistButton';
import SizeChartPopup from 'Component/SizeChartPopup';
import { WOMEN_LABELS } from 'Component/SizeChartPopup/SizeChartPopup.config';
import TabbyPdp from 'Component/TabbyPdp';
import TamaraPdp from 'Component/TamaraPdp';
import TextPlaceholder from 'Component/TextPlaceholder';
import { GRID_LAYOUT } from 'Route/CategoryPage/CategoryPage.config';
import {
    ProductActions as SourceProductActions
} from 'SourceComponent/ProductActions/ProductActions.component';
import { DeviceType } from 'Type/Device.type';
import { ProductType } from 'Type/ProductList.type';
import { isCrawler, isSSR } from 'Util/Browser';
import BrowserDatabase from 'Util/BrowserDatabase';
import getStore from 'Util/Store';
import { convertQueryStringToKeyValuePairs } from 'Util/Url';

import { DEFAULT_MAX_PRODUCTS } from './ProductActions.config';

import './ProductActions.style';
import './ProductActions.style.override';

/**
 * Product actions
 * @class ProductActions
 * @namespace Scandipwa/Component/ProductActions/Component */
export class ProductActionsComponent extends SourceProductActions {
    static propTypes = {
        ...super.propTypes,
        productOrVariant: ProductType.isRequired,
        configurableVariantIndex: PropTypes.number,
        showOnlyIfLoaded: PropTypes.func.isRequired,
        updateConfigurableVariant: PropTypes.func.isRequired,
        parameters: PropTypes.objectOf(PropTypes.string).isRequired,
        getIsSizeDisabled: PropTypes.func.isRequired,
        groupedProductQuantity: PropTypes.objectOf(PropTypes.number).isRequired,
        clearGroupedProductQuantity: PropTypes.func.isRequired,
        setGroupedProductQuantity: PropTypes.func.isRequired,
        getSelectedCustomizableOptions: PropTypes.func.isRequired,
        productOptionsData: PropTypes.object.isRequired,
        offerCount: PropTypes.number.isRequired,
        offerType: PropTypes.string.isRequired,
        stockMeta: PropTypes.string.isRequired,
        metaLink: PropTypes.string.isRequired,
        device: DeviceType.isRequired,
        productForGallery: PropTypes.object.isRequired,
        updateConfigurableVariantAndQty: PropTypes.func.isRequired,
        handleSizeChartClick: PropTypes.func.isRequired,
        variantsHighPrice: PropTypes.number,
        setIsFooterBootomSpaceNeeded: PropTypes.func.isRequired,
        promoExcludedNotice: PropTypes.string.isRequired
    };

    static defaultProps = {
        ...super.defaultProps,
        variantsHighPrice: null
    };

    state = {
        isVariantsOutOfStock: false,
        isSelectedVariantOutOfStock: false,
        attributeValidation: { isSizeValid: true, isColorValid: true }
    };

    componentDidUpdate(prevProps) {
        const { product: prevProduct } = prevProps;
        const { product } = this.props;
        const { gender } = this.state;

        if (product !== prevProduct || !gender) {
            const productAttributes = BrowserDatabase.getItem('productAttributes');

            if (!productAttributes
                || Object.keys(product).length === 0
                || Object.keys(product.attributes).length === 0) {
                return;
            }

            const {
                product: {
                    gender: productGender
                }
            } = this.props;

            const { customAttributeMetadata: { items } } = productAttributes;
            const result = { gender: null };

            items.forEach((item) => {
                const { attribute_code } = item;

                if (attribute_code === 'gender') {
                    const { attribute_options } = item;

                    attribute_options.forEach(({ value, label }) => {
                        if (+value === +productGender) {
                            result.gender = label;
                            // eslint-disable-next-line no-useless-return
                            return;
                        }
                    });

                    // eslint-disable-next-line no-useless-return
                    return;
                }
            });

            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ gender: result.gender });
        }
    }

    renderStock(stockStatus) {
        if (stockStatus === 'OUT_OF_STOCK') {
            return (
                <div block="ProductActions" elem="Stock">
                    <span block="ProductActions" elem="StockIconWrapper">
                        <span block="ProductActions" elem="StockIcon" />
                    </span>
                    <span>{ __('Out of stock') }</span>
                </div>
            );
        }

        return (
            <span block="ProductActions" elem="Stock">
                <div block="Icon" elem="InStock" />
                <span block="ProductActions" elem="StockStatusLabel">
                    { __('In stock') }
                </span>
            </span>
        );
    }

    renderSku() {
        const {
            getActiveProduct,
            showOnlyIfLoaded,
            getPreviewProduct
        } = this.props;

        // eslint-disable-next-line fp/no-let
        let { style_number } = getActiveProduct();

        if (!style_number) {
            const { style_number: previewStyleNumber } = getPreviewProduct();

            style_number = previewStyleNumber;
        }

        return (
            <section
              block="ProductActions"
              elem="Section"
              mods={ { type: 'sku' } }
              aria-label="Product SKU and availability"
            >
                { showOnlyIfLoaded(
                    style_number,
                    (
                        <>
                            <span block="ProductActions" elem="Sku">
                                { __('Art:.') }
                            </span>
                            <span block="ProductActions" elem="Sku" itemProp="sku" dir="ltr">
                                { `${ style_number }` }
                            </span>
                        </>
                    ),
                    <TextPlaceholder />
                ) }
            </section>
        );
    }

    renderStockStatus() {
        const {
            getActiveProduct,
            getPreviewProduct,
            areDetailsLoaded,
            product
        } = this.props;

        if (!areDetailsLoaded) {
            return (
                <span block="ProductActions" elem="Stock">
                    <TextPlaceholder length="short" />
                </span>
            );
        }

        const { variants } = product;

        const variantsInStock = variants.filter((variant) => (variant.stock_status === 'IN_STOCK'));
        const stockCount = variantsInStock.reduce((acc, variant) => {
            const styleNumber = variant.style_number;
            const qty = variant.salable_qty;

            if (acc[styleNumber] === undefined) {
                acc[styleNumber] = qty;
            } else {
                acc[styleNumber] += qty;
            }

            return acc;
        }, {});

        const variant = getPreviewProduct() || getActiveProduct();
        const productSalableQuantity = variants
            // eslint-disable-next-line no-magic-numbers
            ? stockCount[variant.style_number]
            : variant.salable_qty;

        const stockStatus = !variantsInStock.length ? 'OUT_OF_STOCK' : productSalableQuantity || variant.stock_status;

        if (!variantsInStock.length) {
            this.setState({
                isVariantsOutOfStock: true
            });
        } else {
            this.setState({
                isVariantsOutOfStock: false
            });
        }

        if (stockStatus === 'OUT_OF_STOCK') {
            this.setState({ isSelectedVariantOutOfStock: true });
        } else {
            this.setState({ isSelectedVariantOutOfStock: false });
        }

        return this.renderStock(stockStatus);
    }

    renderPromoExcludedNotice() {
        const {
            promoExcludedNotice,
            areDetailsLoaded,
            getPreviewProduct,
            getActiveProduct
        } = this.props;

        if (!areDetailsLoaded) {
            return null;
        }

        const { promo_excluded_flag } = getPreviewProduct() || getActiveProduct();

        if (!promo_excluded_flag || !promoExcludedNotice) {
            return null;
        }

        return (
            <div
              block="ProductActions"
              elem="PromoExcludedNotice"
            >
                { promoExcludedNotice }
            </div>
        );
    }

    renderModelInformation() {
        const {
            areDetailsLoaded,
            getPreviewProduct,
            getActiveProduct
        } = this.props;

        const { gender } = this.state;

        if (!areDetailsLoaded) {
            return null;
        }

        const { model_height, model_sample_size } = getPreviewProduct() || getActiveProduct();

        if (!model_height || !model_sample_size || !gender) {
            return null;
        }

        return (
            <div
              block="ProductActions"
              elem="ModelInformation"
            >
                <div block="Icon" elem="Info" />
                { WOMEN_LABELS.includes(gender)
                    ? __('FEMALE: Our model is %s cm tall and wears size %s', model_height, model_sample_size)
                    : __('MALE: Our model is %s cm tall and wears size %s', model_height, model_sample_size) }
            </div>
        );
    }

    renderColorAttribute() {
        const {
            getLink,
            updateConfigurableVariantAndQty,
            parameters,
            areDetailsLoaded,
            product,
            product: {
                configurable_options,
                configurable_options: {
                    color
                } = {},
                type_id,
                variants
            },
            getIsConfigurableAttributeAvailable
        } = this.props;
        const { attributeValidation } = this.state;

        if (type_id !== PRODUCT_TYPE.configurable && configurable_options) {
            return null;
        }

        const params = Object.keys(parameters).length !== 0
            ? parameters : convertQueryStringToKeyValuePairs(window.location.search);

        return (
            <div
              ref={ this.configurableOptionsRef }
              block="ProductActions"
              elem="ColorAttributeWrapper"
            >
                <ProductColorAttribute
                    // eslint-disable-next-line no-magic-numbers
                  numberOfPlaceholders={ [3] }
                  mix={ { block: 'ProductActions', elem: 'Attributes' } }
                  isReady={ areDetailsLoaded }
                  getLink={ getLink }
                  parameters={ params }
                  updateConfigurableVariant={ updateConfigurableVariantAndQty }
                  configurable_options={ { color } }
                  getIsConfigurableAttributeAvailable={ getIsConfigurableAttributeAvailable }
                  isContentExpanded
                  product={ product }
                  attributeValidation={ attributeValidation }
                  variants={ variants }
                />
            </div>
        );
    }

    renderSizeAttribute() {
        const {
            getLink,
            parameters,
            areDetailsLoaded,
            product,
            product: { configurable_options, type_id, variants },
            getIsSizeDisabled,
            getIsConfigurableAttributeAvailable,
            updateConfigurableVariantAndQty
        } = this.props;

        const { attributeValidation } = this.state;

        if (type_id !== PRODUCT_TYPE.configurable) {
            return null;
        }

        return (
            <div
              ref={ this.configurableOptionsRef }
              block="ProductActions"
              elem="SizeAttributeWrapper"
            >
                <ProductConfigurableAttributes
                    // eslint-disable-next-line no-magic-numbers
                  numberOfPlaceholders={ [2, 4] }
                  mix={ { block: 'ProductActions', elem: 'Attributes' } }
                  isReady={ areDetailsLoaded }
                  getLink={ getLink }
                  parameters={ parameters }
                  updateConfigurableVariant={ updateConfigurableVariantAndQty }
                  configurable_options={ { size: configurable_options.size } }
                  getIsSizeDisabled={ getIsSizeDisabled }
                  getIsConfigurableAttributeAvailable={ getIsConfigurableAttributeAvailable }
                  innerLabel={ __('Size') }
                  isContentExpanded
                  isLabelInner
                  isSize
                  attributeValidation={ attributeValidation }
                  product={ product }
                  variants={ variants }
                />
            </div>
        );
    }

    renderPrice() {
        const {
            getActiveProduct,
            product: { price_range = null } = {},
            productPrice,
            getPreviewProduct
        } = this.props;

        const product = getActiveProduct();
        const { type_id: activeType, price_tiers: priceTiers = [], price_range: activeProductPrice } = product;

        if (activeType === PRODUCT_TYPE.configurable) {
            const previewProduct = getPreviewProduct();

            if (previewProduct !== false) {
                const { price_range: priceRange } = previewProduct;
                const previewProductPrice = priceRange;

                return (
                    <div
                      block={ this.className }
                      elem="PriceWrapper"
                    >
                        <ProductPrice
                          meta
                          isSchemaRequired
                          variantsCount={ this.props.offerCount }
                          price={ previewProductPrice }
                          priceType={ PRODUCT_TYPE.simple }
                          tierPrices={ priceTiers }
                          isPreview={ false }
                          mix={ { block: this.className, elem: 'Price' } }
                        />
                    </div>
                );
            }
        }

        if (!price_range) {
            return <TextPlaceholder />;
        }

        if (!productPrice) {
            return null;
        }

        return (
            <div
              block={ this.className }
              elem="PriceWrapper"
            >
                <ProductPrice
                  meta
                  isSchemaRequired
                  price={ activeProductPrice }
                  priceType={ activeType }
                  tierPrices={ priceTiers }
                  isPreview={ false }
                  mix={ { block: this.className, elem: 'Price' } }
                />
            </div>
        );
    }

    getPriceForWidgets() {
        const {
            getActiveProduct,
            getPreviewProduct
        } = this.props;

        const product = getActiveProduct();
        const { type_id: activeType, price_range: activeProductPrice } = product;

        if (activeType === PRODUCT_TYPE.configurable) {
            const previewProduct = getPreviewProduct();

            if (previewProduct !== false) {
                const { price_range: priceRange } = previewProduct;
                return priceRange;
            }
        }

        return activeProductPrice;
    }

    renderPdpWidgets() {
        const { pdp_widgets_order } = getStore().getState().ConfigReducer;
        const parsedOrder = pdp_widgets_order ? Object.values(JSON.parse(pdp_widgets_order)) : null;
        const availableOrder = {};

        if (parsedOrder) {
            parsedOrder.forEach((item) => {
                availableOrder[item.payment_method] = item.position;
            });
        }

        return (
            <div
              block="ProductActions"
              elem="WidgetsWrapper"
            >
                { this.renderTamaraWidget(availableOrder.Tamara ? availableOrder.Tamara : 0) }
                { this.renderTabbyWidget(availableOrder.Tabby ? availableOrder.Tabby : 0) }
            </div>
        );
    }

    renderTamaraWidget(order) {
        const { tamaraWidgetPdp } = this.props;

        return (
            <TamaraPdp
              price={ this.getPriceForWidgets() }
              order={ order }
              tamaraWidgetPdp={ tamaraWidgetPdp }
            />
        );
    }

    renderTabbyWidget(order) {
        const { tabbyWidgetPdp } = this.props;

        return (
            <TabbyPdp
              price={ this.getPriceForWidgets() }
              order={ order }
              tabbyWidgetPdp={ tabbyWidgetPdp }
            />
        );
    }

    renderCustomizableOptions() {
        const {
            product: { options },
            getSelectedCustomizableOptions,
            productOptionsData,
            device,
            areDetailsLoaded,
            updateSelectedValues
        } = this.props;

        if (!areDetailsLoaded || (options && options.length === 0)) {
            return null;
        }

        if (device.isMobile) {
            return null;
        }

        return (
            <section
              block="ProductActions"
              elem="Section"
              mods={ { type: 'customizable_options' } }
            >
                <ProductCustomizableOptions
                  options={ options }
                  getSelectedCustomizableOptions={ getSelectedCustomizableOptions }
                  productOptionsData={ productOptionsData }
                  updateSelectedValues={ updateSelectedValues }
                />
            </section>
        );
    }

    renderQuantityChanger() {
        const {
            quantity,
            getPreviewProduct,
            getActiveProduct,
            setQuantity,
            product: { type_id },
            areDetailsLoaded
        } = this.props;

        if (type_id === PRODUCT_TYPE.grouped || !areDetailsLoaded) {
            return null;
        }

        const {
            maxQuantity,
            minQuantity,
            salable_qty
        } = getPreviewProduct() || getActiveProduct();

        const selectOptions = [];

        const maxSaleQuantity = salable_qty < DEFAULT_MAX_PRODUCTS
            ? salable_qty
            : DEFAULT_MAX_PRODUCTS - 1;

        // eslint-disable-next-line fp/no-loops,no-magic-numbers,fp/no-let
        for (let i = 1; i <= maxSaleQuantity; i++) {
            selectOptions.push({
                id: i,
                value: i,
                label: i.toString()
            });
        }

        return (
            <Field
              type={ FIELD_TYPE.select }
              attr={ {
                  id: 'item_qty',
                  name: 'item_qty',
                  value: quantity
              } }
              max={ maxQuantity }
              min={ minQuantity }
              mix={ {
                  block: 'ProductActions',
                  elem: `Qty${ !Object.keys(selectOptions).length ? '-Disabled' : ''}`
              } }
              events={ { onChange: setQuantity } }
              options={ selectOptions }
              isLabelInner
              innerLabel={ __('QTY') }
            />
        );
    }

    getGalleryProduct() {
        const {
            productForGallery,
            product: { type_id },
            getGalleryProduct
        } = this.props;

        if (type_id === PRODUCT_TYPE.configurable) {
            const previewProduct = getGalleryProduct();

            if (previewProduct !== false) {
                return previewProduct;
            }
        }

        return productForGallery;
    }

    renderProductWishlistButton() {
        const {
            magentoProduct,
            isWishlistEnabled,
            product,
            parameters,
            areDetailsLoaded
        } = this.props;

        if (magentoProduct.length === 0 || !isWishlistEnabled) {
            return null;
        }

        return (
            <ProductWishlistButton
              magentoProduct={ magentoProduct }
              selectedProduct={ product }
              parameters={ parameters }
              isPDPLoading={ !areDetailsLoaded }
              mix={ {
                  block: 'ProductActions',
                  elem: 'AddToWishlist'
              } }
            />
        );
    }

    renderAddToCartButton(layout = GRID_LAYOUT) {
        const {
            quantity,
            areDetailsLoaded,
            setIsFooterBootomSpaceNeeded,
            getActiveProduct,
            getPreviewProduct,
            addToCartWithReturn,
            updateSelectedValues
        } = this.props;
        const { isVariantsOutOfStock, isSelectedVariantOutOfStock } = this.state;

        const { salable_qty } = getPreviewProduct() || getActiveProduct();

        if (isVariantsOutOfStock) {
            setIsFooterBootomSpaceNeeded(false);
            return null;
        }

        setIsFooterBootomSpaceNeeded(true);

        return (
            <>
                <AddToCart
                  mix={ { block: 'ProductActions', elem: 'AddToCart' } }
                  salable_qty={ salable_qty }
                  addToCart={ addToCartWithReturn }
                  isDisabled={ isSelectedVariantOutOfStock }
                  isIconEnabled={ false }
                  layout={ layout }
                  updateSelectedValues={ updateSelectedValues }
                  quantity={ quantity }
                  product={ getActiveProduct() }
                  areDetailsLoaded={ areDetailsLoaded }
                />
                { this.renderProductWishlistButton() }
            </>
        );
    }

    renderOfferCount() {
        const { offerCount } = this.props;

        if (offerCount >= 1) {
            return (
                <meta
                  itemProp="offerCount"
                  content={ offerCount }
                />
            );
        }

        return null;
    }

    renderSizeChartPlaceholder() {
        const { handleSizeChartClick, areDetailsLoaded } = this.props;
        const { isVariantsOutOfStock } = this.state;

        return (
            <div
              block="ProductActions"
              elem="SizeChart"
              mods={ { isLoading: !areDetailsLoaded, isVariantsOutOfStock } }
            >
                { !areDetailsLoaded
                    ? <TextPlaceholder content={ false } length="short" />
                    : (
                        <>
                            <button
                              onClick={ handleSizeChartClick }
                            >
                                { __('SIZE GUIDE') }
                            </button>
                            <div block="Icon" />
                        </>
                    ) }
            </div>
        );
    }

    renderMobileInfoBlock() {
        const { device } = this.props;

        if (!device.isMobile) {
            return null;
        }

        return (
            <div
              block="ProductActions"
              elem="MobileInfoBlock"
            >
                { this.renderName() }
                <div
                  block="ProductActions"
                  elem="PriceSkuWrapper"
                >
                    { this.renderPriceWithGlobalSchema() }
                    { this.renderSku() }
                </div>
            </div>
        );
    }

    renderSizeChartPopup() {
        const { product, parameters, areDetailsLoaded } = this.props;

        return (
            <SizeChartPopup
              product={ product }
              parameters={ parameters }
              areDetailsLoaded={ areDetailsLoaded }
            />
        );
    }

    renderAddToCartActionBlock() {
        return (
            <div
              block="ProductActions"
              elem="AddToCartWrapper"
              mods={ { isPrerendered: isSSR() || isCrawler() } }
            >
                { this.renderAddToCartButton() }
            </div>
        );
    }

    renderAddToCartMobile() {
        return (
            <div
              block="ProductActions"
              elem="AddToCartFixed"
              mods={ { isPrerendered: isSSR() || isCrawler() } }
            >
                { this.renderAddToCartButton() }
            </div>
        );
    }

    renderExpandableProductInfo() {
        const {
            areDetailsLoaded,
            product: {
                attributes = {},
                description: { html = '' } = {}
            },
            getActiveProduct,
            getPreviewProduct
        } = this.props;

        if (!areDetailsLoaded) {
            return (
                <TextPlaceholder
                  mix={ { block: 'ProductActions', elem: 'quantityAndSizePlaceholder' } }
                  length="custom"
                />
            );
        }

        const productStoryPart = html.match(/<p>(.*?)<\/p>/);

        if (!productStoryPart) {
            return null;
        }

        // eslint-disable-next-line fp/no-let
        let { style_number, color } = getActiveProduct();

        if (!style_number || !color) {
            const {
                style_number: previewStyleNumber,
                color: previewColor
            } = getPreviewProduct();

            style_number = previewStyleNumber;
            color = previewColor;
        }

        const colorLabel = attributes?.color?.attribute_options?.[color]?.label;

        return (
            <div
              block="ProductActions"
              elem="ExpandableProductInfo"
            >
                <ExpandableContent
                  heading={ __('Description') }
                  mix={ {
                      block: 'ExpandableProductInfo',
                      elem: 'Item'
                  } }
                  isContentExpanded={ false }
                >
                    <p>{ productStoryPart[1] }</p>
                    <ul>
                        <li>
                            { __('Style: ') }
                            <span dir="ltr">{ style_number }</span>
                        </li>
                        { colorLabel && <li>{ __('Color: ') + colorLabel }</li> }
                    </ul>
                    <a
                      id="ProductInformation"
                      block="Link-Animated"
                      href="#ProductInformation"
                    >
                        { __('Read more') }
                    </a>
                </ExpandableContent>
            </div>
        );
    }

    renderQuantityAndSize() {
        const { areDetailsLoaded } = this.props;

        const placeHolder = (
            <TextPlaceholder
              mix={ { block: 'ProductActions', elem: 'quantityAndSizePlaceholder' } }
              length="custom"
            />
        );

        return (
            <div
              block="ProductActions"
              elem="QtyAndSizeWrapper"
              mods={ { isLoading: !areDetailsLoaded } }
            >
                { areDetailsLoaded ? this.renderSizeAttribute() : placeHolder }
                <div
                  block="ProductActions"
                  elem="QtyAndStockWrapper"
                >
                { areDetailsLoaded ? this.renderStockStatus() : null }
                { areDetailsLoaded ? this.renderQuantityChanger() : placeHolder }
                </div>
            </div>
        );
    }

    renderDesktop() {
        const {
            areDetailsLoaded,
            product
        } = this.props;

        return (
            <>
                <div
                  block="ProductActions"
                  elem="ProductLabelDesktop"
                >
                    <ProductLabel
                      product={ product }
                      areDetailsLoaded={ areDetailsLoaded }
                      isPDP
                    />
                </div>
                { this.renderBrand(true) }
                { this.renderName() }
                <div
                  block="ProductActions"
                  elem="PriceSkuWrapper"
                >
                    { this.renderPriceWithGlobalSchema() }
                    { this.renderSku() }
                </div>
                { this.renderPdpWidgets() }
                { this.renderColorAttribute() }
                { this.renderPromoExcludedNotice() }
                { this.renderModelInformation() }
                { this.renderQuantityAndSize() }
                { this.renderTierPrices() }
                { this.renderAddToCartActionBlock() }
                { this.renderSizeChartPlaceholder() }
                { this.renderSizeChartPopup() }
                { this.renderExpandableProductInfo() }
                { this.renderCustomAndBundleOptions() }
                { this.renderGroupedOptions() }
                { this.renderDownloadableSamples() }
                { this.renderDownloadableLinks() }
                { this.renderProductAlerts() }
            </>
        );
    }

    renderMobile() {
        const { product } = this.props;

        return (
            <>
                <div
                  block="ProductActions"
                  elem="ProductLabelMobile"
                >
                    <ProductLabel
                      product={ product }
                    />
                </div>
                <div
                  block="ProductActions"
                  elem="PriceSkuWrapper"
                >
                    { this.renderPriceWithGlobalSchema() }
                    { this.renderSku() }
                </div>
                { this.renderPdpWidgets() }
                { this.renderColorAttribute() }
                { this.renderPromoExcludedNotice() }
                { this.renderModelInformation() }
                { this.renderQuantityAndSize() }
                { this.renderTierPrices() }
                { this.renderSizeChartPlaceholder() }
                { this.renderSizeChartPopup() }
                { this.renderExpandableProductInfo() }
                { this.renderBrand(true) }
                { this.renderProductAlerts() }
                { this.renderCustomAndBundleOptions() }
                { this.renderGroupedOptions() }
                { this.renderDownloadableSamples() }
                { this.renderDownloadableLinks() }
                { this.renderAddToCartMobile() }
            </>
        );
    }

    render() {
        const { areDetailsLoaded, device: { isMobile } = {}, setValidator } = this.props;

        return (
            <>
                { this.renderMobileInfoBlock() }
                <ProductGallery
                  product={ this.getGalleryProduct() }
                  areDetailsLoaded={ areDetailsLoaded }
                />
                <article block="ProductActions" ref={ (elem) => setValidator(elem) }>
                    { isMobile ? this.renderMobile() : this.renderDesktop() }
                </article>
            </>
        );
    }
}

export default ProductActionsComponent;
